import { render, staticRenderFns } from "./IconArrowSwapHorizontal.vue?vue&type=template&id=5c1e6885"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports